import Event from '../event';
import indexEvents from 'actions/event/index';
import indexHomework from 'actions/homework/index';
import indexTasks from 'actions/task/index';
import indexConflicts from 'actions/conflict/index';

/**
 * Create the action
 */

const { thunk, request, success, error } = Event.destroy((id, data, fetch, dispatch) => {


    /*
    example request:
    data: {
        id: 1,
        redit: in case of recurrent event: 'single' or 'future', set to null when non-recurrence event
        origid: (in case of recurrence event, original event id)  
    }
    */

    return fetch.post(`/event-delete/${data.id}`, data).then((response) => {
        dispatch(indexEvents({}));
        dispatch(indexHomework());
        dispatch(indexTasks());
        dispatch(indexConflicts());
        return response;
    });
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
